'use strict';

/* eslint camelcase: 0 */

var request = require('./request');


function deleteSession ( id ) {
    request('media-info/' + id, {
        method: 'DELETE',
        onerror: function ( error ) {
            console.log(error);
        }
    });
}


function Video ( config ) {
    var key;

    config = config || {};

    for ( key in config ) {
        this[key] = config[key];
    }

    if ( config.screenshots && config.screenshots.length ) {
        this.screenshots = config.screenshots.map(function ( url ) {
            return core.stalker.host + url;
        });
    }

    this.requestLinks = {};
}


/**
 * Get and refill information about video.
 *
 * @param {Function} callback - result handler
 */
Video.prototype.refreshData = function ( callback ) {
    request(
        'movies/' + this.id,
        {
            method: 'GET',
            onload: callback,
            onerror: callback
        }
    );
};


/**
 * Change flags.
 *
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Video.prototype.changeFlags = function ( config, callback ) {
    var self = this;

    request(
        'movies/' + this.id,
        {
            method: 'PUT',
            body: JSON.stringify(config),
            onload: function ( error, response ) {
                if ( !error && response && response.data )  {
                    Object.keys(config).forEach(function ( name ) {
                        self[name] = config[name];
                    });
                }

                callback(error, response.data);
            },
            onerror: callback
        }
    );
};


/**
 * Change watched file.
 *
 * @param {number} file - file id
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Video.prototype.changeWatchedFile = function ( file, config, callback ) {
    var self = this;

    request(
        'movies/' + this.id + '/files/' + file,
        {
            method: 'PUT',
            body: JSON.stringify(config),
            onload: function ( error, response ) {
                var data;

                if ( !error && response ) {
                    data = response.data;

                    self.watched_time = config.watched_time;
                    if ( data.movie_watched_status ) {
                        self.watched_status = data.movie_watched_status;
                    }

                    self.last_watched_file_id = file;

                }

                callback(error, data);

            },
            onerror: callback
        }
    );

    if ( config.progress && config.progress >= 70 ) {
        this.sendStatistic(file);
    }
};


/**
 * Send statistic.
 */
Video.prototype.sendStatistic = function () {
    request(
        'media-info',
        {
            method: 'POST',
            body: JSON.stringify({
                type: 'video',
                media_id: this.id
            }),
            onload: function ( error, response ) {
                if ( !error && response && response.data ) {
                    deleteSession(response.data.session_id);
                }
            }
        }
    );
};


/**
 * Change watched season.
 *
 * @param {number} season - season id
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Video.prototype.changeWatchedSeason = function ( season, config, callback ) {
    request(
        'movies/' + this.id + '/seasons/' + season,
        {
            method: 'PUT',
            body: JSON.stringify(config),
            onload: function ( error, response ) {
                if ( !response ) {
                    response = {};
                }

                callback(error, response.data);
            },
            onerror: callback
        }
    );
};


/**
 * Get seasons list.
 *
 * @param {Function} callback - result handler
 */
Video.prototype.getSeasons = function ( callback ) {
    request(
        'movies/' + this.id + '/seasons?limit=200',
        {
            method: 'GET',
            onload: function ( error, response ) {
                callback(error, error ? [] : response.data);
            },
            onerror: callback
        },
        'getSeasons',
        this.requestLinks
    );
};


/**
 * Get series list.
 *
 * @param {number} seasonId - season id
 * @param {Function} callback - result handler
 */
Video.prototype.getSeries = function ( seasonId, callback ) {
    request(
        'movies/' + this.id + '/seasons/' + seasonId + '/episodes?limit=200',
        {
            method: 'GET',
            onload: function ( error, response ) {
                var index, state,
                    watched, data;

                response = response || {};

                if ( !error ) {
                    data = response.data || [];

                    data.forEach(function ( item ) {
                        state = 'not_watched';
                        watched = true;
                        for ( index = 0; index < item.files.length; index++ ) {
                            if ( item.files[index].watched_status === 'watched' ) {
                                state = 'watched';
                                watched = false;
                                break;
                            }
                        }
                        if ( watched ) {
                            for ( index = 0; index < item.files.length; index++ ) {
                                if ( item.files[index].watched_status === 'not_ended' ) {
                                    state = 'not_ended';
                                    break;
                                }
                            }
                        }
                        item.watched_status = state;
                    });
                }

                callback(error, data);
            },
            onerror: callback
        },
        'getSeries',
        this.requestLinks
    );
};


/**
 * Get episode information.
 *
 * @param {Object} data - request
 * @param {Function} callback - result handler
 */
Video.prototype.getEpisode = function ( data, callback ) {
    request(
        'movies/' + this.id + '/seasons/' + data.seasonId + '/episodes/' + data.episodeId,
        {
            method: 'GET',
            onload: function ( error, response ) {
                response = response || {};

                callback(error, response.data);
            },
            onerror: callback
        },
        'getSeries',
        this.requestLinks
    );
};


/**
 * Get link to play.
 *
 * @param {number} fileId - file id
 * @param {Function} callback - result handler
 */
Video.prototype.getUrl = function ( fileId, callback ) {
    request(
        'movies/' + this.id + '/files/' + fileId + '/link',
        {
            method: 'GET',
            onload: function ( error, response ) {
                callback(error, error ? null : response.data.url);
            },
            onerror: callback
        }
    );
};


module.exports = Video;
